export const MEMBER_ROLES = {
  patient: 'Member',
  peer: 'Peer',
  counselor: 'Counselor',
  admin: 'Admin',
  super_admin: 'Super Admin',
} as const;

export type MemberRole = keyof typeof MEMBER_ROLES;
